export default "__VITE_ASSET__C7vIBx7f__"